import React, { useEffect, useState } from 'react'
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import Video from '../../../../Components/Icons/Video';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import CloseIcon from '../../../../Components/Icons/Close';
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import { useToast } from '../../../../Components/Others/ToastServices';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseDropDown from '../../../../Components/Hooks/useDropDown';

import MultiSelect, { MultiSelectSet } from '../../../../Components/Utils/MultiSelect';
import TextArea from 'antd/es/input/TextArea';

const EditCalendar = ({EditNew,open, fetchData=()=>{}, onCancel, data,id,task }) => {

  console.log("data task",task);
  
  const { value: status,getData:refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Task"
  );
  const { data: user } = UseDropDown(`/user/drop-down`);
   
  const [selectedFile, setSelectedFile] = useState(null);
      
    const {officeId} = useParams();
    const [api, contextHolder] = notification.useNotification();
    const [createNew, setCreateNew] = useState({
           date:"",
        description:"",
        filesToRemove:[],
        
        status:"",
        taskCompletion:""
    });
    useEffect(() => {
      task&&setCreateNew({
        date:task.date,
        description:task.description,
        status:task.status,

        taskCompletion:status.taskCompletion,
      })
    },[data])
      const { Oncancel, editFormData, isLoading } = useEditFormData();
      const [filePathList, setFilePathList] = useState([]);
      const [fileRemoveList, setFileRemoveList] = useState([]);
     const [image, setImage] = useState([]);
      const toast = useToast();
      const [removefilePathList, setRemoveFilePathList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
      const [selectedImage, setSelectedImage] = useState(null);
      const [fileExtention, setFileExtention] = useState("");
    
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema:yup.object({
       
    }),
      onSubmit: (value,{resetForm}) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
       
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
       
        axiosInstance.put(`/calendar/task/${task?.id}`, formData, resetForm)
        .then((res) => {
            console.log("res",res.data.status);
            if (res.data.status) {
              api.success({
                message: `Task Update successfully`,
                description: res?.data?.msg || "Added In The Task",
                placement: "bottomRight",
              });
              fetchData();
              resetForm();
              onCancel();
            } else {
              api.error({
                message: `Task Upadate failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            
            api.error({
              message: `failed`,
              description: err?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
    });
  
 
    function handleImageChange(e) {
      const maxFileSize = 200000000; // 200 MB
      const files = Array.from(e.target.files);
      let fileArr = [];
      files.map((item) => {
        if (item.size < maxFileSize) {
          fileArr.push(item);
        } else {
          toast.open({
            type: "warning",
            message: `File Size to big`,
            description: `${item.name} is Removed and not Uploaded`,
            // placement: "bottomRight",
          });
        }
      });
      let tempArr = [];
      setSelectedFile(fileArr);
      files.map((item) => {
        if (item.size < maxFileSize) {
          let fileName = item?.name;
          console.log("fname", fileName);
          // let fileExtention = fileName.split(".").reverse()[0];
          // if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
          // } else {
          //   let x = URL.createObjectURL(item);
          //   tempArr.push(x);
          // }
        }
      });
      console.log(tempArr, "temp");
      setImage(tempArr);
    }
  
    useEffect(() => {
      if (
        data?.attachments !== null &&
        data?.attachments !== "None" &&
        data?.attachments !== "[]"
      ) {
        // console.log(data.attachments, "ghjkllgd");
        setFilePathList(data?.attachments);
  
        setRemoveFilePathList(data?.attachments);
      }
    }, [data]);
  
    function UpdateAttachmentList(item) {
      let filterList = filePathList.filter((itemList) => itemList.file !== item);
      let removeFile = filePathList.find((itemList) => itemList.file === item);
      console.log("llll", filterList);
      setFileRemoveList([...fileRemoveList, removeFile.file]);
      setFilePathList(filterList);
    }
    function handleImageClick(img) {
      let Ext = img?.file_name.split(".").reverse()[0];
      setSelectedImage(img);
      setFileExtention(Ext);
      setIsModalOpen(true);
    }
  
    return (
      <>
      {contextHolder}
      <Modal
  open={open}
  title={data ? "Edit Task" : "Edit Task"}
  width="50%"
  className="perfect-centered-modal"
  centered
  onCancel={onCancel}
  footer={null}
  styles={{
    body: {
      maxHeight: '70vh',
      overflowY: 'auto',
      padding: '4px'
    }
  }}
>
      <form onSubmit={formik.handleSubmit} >
       <div className=" w-full flex flex-wrap">
         <NuDate
                      label="Date"
                      formik={formik}
                      name="date"
                      width="w-full "
                    />
                       <MultiSelect
                       label="Assignee"
                                     type="text"
                                     Options={user}
                                     placeholder="Choose Assignee"
                                    //  value={selectedUsers}
                                    //  onChange={handleUserSelect}
                                     isMulti={true}
                                     formik={formik}
                                     name="assignees"
                                     width="w-full"
                                   />
               <FormikSelectTwo
                type="text"
                label="Status"
                placeholder="Choose Status"
                Options={status}
                formik={formik}
                name="status"
                width="w-full"
                 />
              <NuTextArea
                            type="text"
                            label="Description"
                            placeholder="Type here"
                            formik={formik}
                            name="description"
                            new_width="w-full "
                          />
               <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                  />
                </div>
              </div>
  <button
                type="submit"
               
                className="w-11/12 bg-baseColor-primary py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
              >
                Update 
              </button>
            </div>
       
      </form>
      </Modal>
      </>
    );
  };
  
  

export default EditCalendar